<div class="comparisonWrap">
    <div class="trinkavsGarmmarlyBanner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="bannerContent">
                        <h1>Writefull以外の英文校閲ツ<br />ールをお探しですか？
                        </h1>
                        <p>Writefull有料プランからTrinkaへの乗り換えをお考えの方に、お支払い済みの代金が無駄にならないお得な乗り換え方法をご用意しています。</p>
                        <div class="bannerContentButtons try_a_free_form">
                            <!-- <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="itsFreeButton">ユーザー登録して利用する（無料）
                        </a>
                        <span class="orTrydemoButton">
                            <a [routerLink]="['/try-a-demo']">
                                登録なしのデモ版を試してみる
                            </a>
                        </span> -->
                            <form [formGroup]="compareTrinkaGrammarly" (ngSubmit)="onSubmitEmail()">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group" [ngClass]="(!compareTrinkaGrammarly.get('userEmailId').valid && compareTrinkaGrammarly.get('userEmailId').dirty) || (compareTrinkaGrammarly.get('userEmailId').touched && compareTrinkaGrammarly.get('userEmailId').pristine) ? 'TextFiledError' : '' ">
                                            <mat-form-field appearance="outline">
                                                <mat-label>メールアドレス *</mat-label>
                                                <input id="contactUserEmail" matInput placeholder="" formControlName="userEmailId" class="form-control">
                                            </mat-form-field>
                                            <button type="submit">無料で登録する</button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="grammarlyTestimonials">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonialsContent">
                    <img src="assets/images/double_quotes_icon.png" alt="アイコン">
                    <p>Trinkaは、Writefullに比べ、正確な文法チェックとしっかりとした英語の改善をしてくれます。これまでにない最高のオンライン英文校閲ツールです。</p>
                    <h3>生化学者、日本 </h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="switch_from_grammarly custom_width">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>WritefullからTrinkaへの乗り換えを
                        <br>お考えの方に、朗報です！</h2>
                    <div class="HeadingSubLine"></div>
                    <p>「Trinkaを使いたいけれど、Writefull有料プランの料金を支払い済み・・・。」そんな方にも無駄なくTrinkaのプレミアムプランにお乗り換えいただけるよう、お得な乗り換え方法をご用意しています。</p>
                    <div class="sample_exmple">
                        <p>
                            <b>Writefull（年払い）をすでにご契約の場合：</b>
                        </p>
                        <p>契約開始日：2021年1月5日</p>
                        <p>乗り換えの日付：2021年4月25日</p>
                        <p>残りの利用可能期間：255日</p>
                    </div>
                    <div class="how_it_work">
                        <a (click)="scroll(target)" class="itsFreeButton">乗り換え方法を見る</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="free_premium">
                    <div class="free_premium_border">
                        <div class="discount-label yellow">
                            <span>特別オファー</span>
                        </div>
                        <div class="free_premium_title">
                            プレミアムプラン
                            <br>ご利用期間計算機
                        </div>
                        <i>Writefullからの乗り換えで、Trinkaのプレミアムプラン利用期間が何日延長されるか算出します。</i>
                        <div class="free_premium_form">
                            <!-- <form> -->
                            <div class="textbox_content form-group">
                                <label>Writefull有料プランのご利用開始日</label>
                                <input placeholder="MM/DD/YY" type="date" class="form-control" (change)="premiumDateChanged($event)">
                                <label>プラン</label>
                                <select class="custom-select" [ngModel]="grammarlySelect" (change)="planTypeChanged($event)">
                                    <option selected value="">プラン</option>
                                    <option value="M">月払い</option>
                                    <option value="Y">年払い</option>
                                </select>
                            </div>
                            <!-- </form> -->
                            <p *ngIf="finalTextContent" class="form_status">本日Trinkaのプレミアムプランの年払いにお申し込みいただくと、ご利用期間は
                                <span>{{diffDays}}</span> 日延長されます。 ({{currentDate | date:'dd-MM-yyyy'}})
                            </p>

                            <!-- <h3>Example for Grammarly Premium Annual Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 April 2021</p> 
                            <p>Addition free days you will get: 255 days</p> 
                            <h3 class="mart15">Example for Grammarly Premium Monthly Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 January 2021</p> 
                            <p>Addition free days you will get: 20 days</p>  -->
                        </div>
                        <span class="validTextSection">* 延長は、Trinkaプレミアムプランのお支払いをクレジットカード/<br />
                            デビットカードで行っていただく場合にのみご利用いただけます。</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="compare_tables_discriptions">
                    <h2>TrinkaとWritefullの違い</h2>
                    <div class="HeadingSubLine"></div>
                    <p>クラウドベースのオンライン英文校閲ツールTrinka（トリンカ）が、高度な文法修正、専門分野に合わせた修正、スペルチェックなど、学術文献およびテクニカルライティングに必要なチェックポイントでWritefullよりどこが優れているのかをまとめました。</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <table class="table">
                        <tr>
                            <th>機能</th>
                            <th>Trinka</th>
                            <th>Writefull</th>
                        </tr>
                        <tr>
                            <td>
                                スタイルガイドへの準拠
                                <b>（APA、AMAをはじめとした各種ガイドに即した語法）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                専門分野に合わせた用語・語法
                                <b>（医学、ライフサイエンス、工学など、分野に合わせた修正を提案）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                専門用語のスペル
                                <b>（分野に合わせたスペルを提案）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                専門的な言い回し
                                <b>（その分野で使われる用語、フレーズを提案）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                用語統一チェック
                                <b>（ダッシュなどの記号、スペル、数値の表記法など細かい点もチェック）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                盗用・剽窃チェック
                                <b>（インターネット、オープンアクセス文書、さらに有料出版物の内容との類似性をチェックします。）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                出版適正チェック
                                <b>（論文受理の可能性を高める20以上のチェックポイントで査定）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                ファイル自動校正
                                <b>（Wordファイルでアップロードすれば、数分で自動校正が完了）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                変更提案の一括承認／すべて無視、いずれも可能
                                <b>（修正案の一括反映／すべて無視もワンクリックで完了）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                適切な表現
                                <b>（意図しない不適切な言葉遣いや偏向のある表現の修正）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>あいまいな表現の明確化
                                <b>（分かりやすく明確な英文に修正）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>引用チェック
                                <b>(論文に信頼性の高い強固な文献を引用する)</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>オンライン校正
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>ブラウザプラグイン</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>Wordプラグイン</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>学術的な文体</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>単語数削減</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>高度な文法チェック</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>文構造の修正</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>より良い単語の提案</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>アメリカ英語／イギリス英語の選択</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>細やかな説明とヒント</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>
                        <tr>
                            <td>辞書機能のカスタマイズ</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="アイコン">
                            </td>
                        </tr>

                    </table>
                </div>
                <div class="disclaimerContainer disclaimerContainer_table">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="disclaimercontents">
                                    <p>こちらは、学生、研究者、図書館職員、教員の皆様がご自分に合った<a href="/grammar-checker" class="text-link">英文チェッカー</a>・英文校正ツールをお選びいただけるよう作成した比較表です。不備等ございましたら
                                        <a href="mailto:support@trinka.ai" class="text-link">メール</a>にてお知らせください。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="try_trinka_Buttons">
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">ユーザー登録して利用する（無料）</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pricing_plan">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="pricing_plan_tables">
                    <h2>料金プラン</h2>
                    <div class="HeadingSubLine"></div>
                    <p>ぜひ各社英文校閲ツールの機能を比較してみてください。Trinkaは単なる<a [routerLink]="['/grammar-checker']" class="text-link">文法チェッカー</a>ではなく、学術論文・テクニカルライティングに特化した英文校正ツールです。</p>
                </div>
                <div class="compare_tabels">
                    <div class="pricing_plan_details match-box row justify-content-center">
                        <div class="pricing_details col-md-5 col-lg-5 dflex no-gutter">
                            <div class="c-card">
                                <div class="plan_name">
                                    <div class="plan_name_left">
                                        <label>Trinka
                                            <br>Free</label>
                                        <div class="pricing">
                                            <div class="price">
                                                $0
                                                <b>/ month</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="plan_name_right">
                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文チ ェッカー" width="136">
                                    </div>
                                </div>
                                <ul>
                                    <li>料金プラン</li>
                                    <li>構文修正</li>
                                    <li>専門用語の選択</li>
                                    <li>文脈に即したスペルチェック</li>
                                    <li>単語数削減</li>
                                    <li>語法、文体修正</li>
                                    <li>ファイル自動校正</li>
                                    <li>スタイルガイドへの準拠</li>
                                    <li>用語・表記統一</li>
                                    <li>盗用・剽窃チェック</li>
                                    <li>引用チェック</li>
                                    <li>出版に適したライティング
                                        <br>
                                        <small>(適正な専門用語, 単語数削減 etc.)</small>
                                    </li>
                                    <li>出版適正チェック
                                        <br>
                                        <small>(投稿先ジャーナルとの適合性, 要約生成 etc.)</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="pricing_details col-md-5 col-lg-5 dflex no-gutter">
                            <div class="c-card">
                                <div class="plan_name">
                                    <div class="plan_name_left">
                                        <label>Writefull <br/>Premium</label>
                                        <div class="pricing">
                                            <div class="price">
                                                $8.16
                                                <b>/ month</b>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="plan_name_right">
                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo - ai英文校正" width="150">
                                    </div>
                                </div>

                                <ul>
                                    <li>文法・自然な文体のチェック</li>
                                    <li>お気に入り文章の保存・貼り付け機能</li>
                                    <li>適正な用語の提示</li>
                                    <li>スペルチェック</li>
                                    <li>単語数カウント</li>
                                    <li>文章のトーンの洗練</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
<div class="trinkaBetterThanOthers">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="betterThenContent">
                    <h2>Trinkaが他の英文校閲ツールより優れている理由はここにあります</h2>
                    <div class="HeadingSubLine"></div>
                    <p>高度なライティングには高度な校正・校閲が求められます。それをすべて自動で行うTrinka（トリンカ）は、 学術文献やテクニカルライティングに特化した、AI搭載の英文校閲ツールです。</p>
                    <p>
                        Trinkaに搭載された各種の校正・校閲機能は、英文の文法、スペル、句読点などをチェックするだけでなく、論文出版の可能性を高める文章改善の提案も行います。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="betterThenImg">
                    <img src="assets/images/BetterThen_img.png" alt="最高の文法チェッカーツール">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="件名文法チェッカーツール">
                        <h3>専門分野と文書の種類</h3>
                    </div>
                    <p>原稿の分野や種類に即した最適な提案を表示させる機能のカスタマイズが可能。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/style_guide_icon.svg" alt="スタイルガイドのチェック - 英文校正">
                        <h3>スタイルガイドへの準拠</h3>
                    </div>
                    <p>学術論文の各スタイルガイドに即した語法を提案。 (AMA 11th, AGU 2017等)</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/autoFileEdit_icon.svg" alt="自動ファイル編集 - 英文チ ェッカー">
                        <h3>ファイル自動校正</h3>
                    </div>
                    <p>Wordファイルでアップロードすれば、Trinkaが変更履歴を残しながら自動校正。あとはダウンロードしたファイルを推敲するだけ。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/Icon_PublicationChecks.png" alt="出版物チェック - ai英文校正" style="max-width: 30px;">
                        <h3>出版適正チェック</h3>
                    </div>
                    <p>論文受理の可能性を高めるため、ジャーナルとの相性から、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで文書を査定。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards commingSoonTag">
                    <div class="features_cardsHeading">
                        <img src="assets/images/ConsistencyCheck_icons.png" alt="整合性チェック - 文法 チェック" style="max-width: 30px;">
                        <h3>用語統一チェック</h3>
                    </div>
                    <p>Trinkaなら、様々なタイプの表記ゆれを一斉に検出し、どれだけ長大な文書でもワンクリックで修正可能。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/DownloadTrackChangesEdit_icon.png" alt="変更を追跡する - 英文 チェック ai" style="max-width: 22px;">
                        <h3>変更履歴ファイルのダウンロード</h3>
                    </div>
                    <p>残したい変更履歴だけを付けたファイルをダウンロードして、そこから最終稿をらくらく作成。</p>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="professionalAcademic">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>学術論文・テクニカルライティングに特化した英文校正ツールTrinka</h2>
                <div class="HeadingSubLine"></div>
                <p>Trinka（トリンカ）は、3000種類以上の文法ミスのチェック、文体やトーンの改善、高度なライティングのヒントの提示などを行い、学術論文やテクニカルライティングの英語・英文法を総合的に改善するツールです。</p>
                <div class="grammarCorrectionSlide">
                    <!-- <i>原文</i>
                    <p>The beautiful part of this writing assistant, is one it works very fast quickly, <br>secondly second it doesn’t requires does not require any effort from the writer.</p> -->
                    <div class="grammarCorrectionMain">

                        <!-- <div class="sliderHeading">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="sliderLeftSideHeading">
                                            <div class="grammerlyLogo">
                                                <img src="assets/images/grammarly-logo.png" alt="アイコン">
                                            </div>
                                            <div class="trinkaCorrections">
                                                <p>The beautiful part of this writing assistant, is one it works very fast quickly, secondly second it doesn’t <b>requires</b>&nbsp; <span>require</span> any effort from the writer.</p> 
                                              </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="sliderRightSideHeading">
                                            <div class="trinkaLogo">
                                                <img src="assets/images/trinka-logo.png" alt="trinka logo"> 
                                            </div>
                                            <div class="trinkaCorrections">
                                                <p>The beautiful part of this writing assistant, is one it works <b>very fast</b>&nbsp;<span>quickly,</span> secondly second it <b>doesn’t requires</b>&nbsp;<span>does not require</span> any effort from the writer.</p>
                                            </div>
                                        </div>
                                    </div>
                                     
                                </div>
                            </div> -->
                        <div class="carousel slide" id="keyBenefitContentTwo" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#keyBenefitContentTwo" data-slide-to="0" class="active"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="1"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="2"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="3"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="4"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="5"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="6"></li>
                            </ol>

                            <div class="carousel-inner">

                                <div class="carousel-item active">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>Brazilian soils has low levels of phosphorus available, due to high acidity, therefore,
                                            are fundamental the application of phosphate fertilizers for high yields.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus available, due to high acidity,
                                                            therefore, are fundamental
                                                            <span>to</span> the application of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文校正">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus
                                                            <b>available, due to </b>&nbsp;
                                                            <span>because of</span> high acidity,
                                                            <span>and </span> therefore, are fundamental
                                                            <span>to</span> the application of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply, is a major cause
                                            of death and affect annually approximately 795,000.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect</b>&nbsp;
                                                            <span>affects</span>&nbsp;annually approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文校正">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect annually </b>&nbsp;
                                                            <span>annually affects </span> approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin ratio
                                            (w/w) of 50:1 at 37°C for overnight.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>The depleted proteins were finally digested by trypsin
                                                            <b>at</b>&nbsp;
                                                            <span>in</span> a protein/trypsin ratio (w/w) of 50:1 at 37°C for overnight.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文校正">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>The depleted proteins were finally digested
                                                            <b>by</b>&nbsp;
                                                            <span>with</span> trypsin at a protein/trypsin ratio (w/w) of 50:1
                                                            at 37°C
                                                            <b>for</b> overnight.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>Belladonna leaves as well as all other studied leaves contains two distinct phosphatase
                                            fraction belonging to types II and III.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Belladonna leaves, as well as all other studied leaves
                                                            <span>,</span>
                                                            <b>contains</b>&nbsp;
                                                            <span>contain </span> two distinct phosphatase
                                                            <b>fraction</b>&nbsp;
                                                            <span>fractions</span> belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文校正">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>Belladonna leaves
                                                            <b>as well as all</b>&nbsp;
                                                            <span>and </span> other
                                                            <b>studied</b> leaves
                                                            <span>being studied </span>
                                                            <b>contains</b>
                                                            <span>contain</span>&nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions </span>belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>He sees signs of long term starvation, worse even than what he saw in Arkansas.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>He sees signs of
                                                            <b>long term</b>&nbsp;
                                                            <span>long-term </span> starvation, worse even than what he saw in
                                                            Arkansas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文チ ェッカー">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation,
                                                            <span>even</span> worse
                                                            <b>even</b> than what he saw in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>This kind of political torn-foolery has to a considerable extend prevented our movies
                                            from examining the actual problems of success.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>This kind of political torn-foolery has to a considerable
                                                            <b>extend</b>&nbsp;
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - 英文チ ェッカー">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>
                                                            <b>This kind of</b>&nbsp;
                                                            <span>Such</span> political
                                                            <b>torn-foolery</b>&nbsp;
                                                            <span>tomfoolery</span> has to a considerable
                                                            <b>extend</b>&nbsp;
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text OpenSansFonts">
                                        <i>原文</i>
                                        <p>The results shows 234 differently expressed proteins (DEP) between GBM to normal
                                            brain tissues.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/writefull_logo.png" alt="writefull_logo">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>The results
                                                            <b>shows</b>&nbsp;
                                                            <span>show</span> 234 differently expressed proteins (DEP) between
                                                            GBM to normal brain tissues.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="trinka logo - ai英文校正">
                                                    </div>
                                                    <div class="trinkaCorrections OpenSansFonts">
                                                        <p>The results
                                                            <b>shows</b>&nbsp;
                                                            <span>show</span> 234
                                                            <b>differently</b>&nbsp;
                                                            <span>differentially</span> expressed proteins (
                                                            <b>DEP</b>
                                                            <span>DEPs</span>) between GBM
                                                            <b>to</b>&nbsp;
                                                            <span>and</span>&nbsp;normal brain
                                                            <b>tissues</b>&nbsp;
                                                            <span>tissue</span>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="compare_top_tools">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="top_tools_image">
                    <img src="assets/images/top_tools_compare.png" alt="ツールの比較 - 英文校正">
                </div>
            </div>
            <div class="col-lg-7">
                <div class="top_tools_text_contents">
                    <div class="howItWorkHeading lineWhiteColor">
                        <h3>Trinkaと他のメジャーな英文校閲ツールの違い</h3>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <p>WritefullからTrinkaに乗り換えるメリットは何でしょうか？私たちは、5つの学術系ドメインから集めた5,778語の英文のGrammarly PremiumとLanguageToolによる文法チェックを検証し、訂正箇所の正確さ、スタイルガイドの好み、簡潔さ、文脈に沿ったスペルチェックなど、フォーマルな文章やテクニカルライティングに欠かせない要素を比較しました。比較検証の詳細に関するこちらの解説資料をご覧ください。
                    </p>
                    <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">
                        比較資料を無料ダウンロードする
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="meetTrinka_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>高度なライティングに求められる高度な英文校閲ツール、Trinka</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="meetTrinkaCard">
                    <div class="meetTrinka_img">
                        <img src="assets/images/GoBeyondGrammar&Spelling.svg" alt="文法 チェック">
                    </div>
                    <h3>単なる文法・スペルチェック機能 以上の精度
                    </h3>
                    <p>Trinkaは単なる<a [routerLink]="['/grammar-checker']" class="text-link">文法チェッカー</a>ではなく、他のツールでは見つけられない学術文献やテクニカルライティング特有の英語のミスを検知して修正を提案する英文校閲ツールです。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard unmatched_sections">
                    <div class="meetTrinka_img">

                        <img src="assets/images/UnmatchedWritingEnhancements.svg" alt="比類のないライティング強化 - 英文チ ェッカー">
                    </div>
                    <h3>圧倒的なアカデミック ライティングの改善
                    </h3>
                    <p>Trinkaを使うことで、文体やトーン、用語の選択を学術出版に適したものに改善できます。
                    </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard learnAndHelps">
                    <div class="meetTrinka_img">
                        <img src="assets/images/Learns&HelpsYou.svg"alt="英文ライティング力の向上 - 英文校正">
                    </div>
                    <h3>英文ライティング力の向上</h3>
                    <p>修正案に加えて詳細な説明や提案、ライティングのヒントも提示されるため、使い続けることでライティング力の向上につながります。</p>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="meetTrinka_sections switchToTrinka padt0" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>WritefullからTrinkaへの乗り換えをお考えの方に、朗報です！</h2>
                    <div class="HeadingSubLine"></div>
                    <p>「Trinkaを使いたいけれど、Writefull有料プランの料金を支払い済み・・・。」そんな方にも無駄なくTrinkaのプレミアムプランにお乗り換えいただけるよう、お得な乗り換え方法をご用意しています。</p>
                    <p>ぜひ、Trinkaにお乗り換えいただき、高精度の文法修正をはじめとした、学術論文・テクニカルライティングに最適な英文校閲機能をご利用ください。</p>
                    <p>お申し込みは3ステップで完了です。</p>
                </div>
            </div>
        </div>
        <div class="key_takewaye_sections">
            <h2>乗り換え方法</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>1</p>
                        </div>
                        <div class="need_cards_body">
                            <p>まずはTrinkaの
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="text-link">無料アカウントを作成</a>。学術論文・テクニカルライティングに特化した校正ツールの各種機能をすぐにご利用いただけます。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>2</p>
                        </div>
                        <div class="need_cards_body">
                            <p>アカウントへのログイン後、ダッシュボード右上にある「Upgrade」からプレミアムプランをご購入。「Annual（年払い）」を選択し、お支払い手続きを行ってください。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>3</p>
                        </div>
                        <div class="need_cards_body">

                            <p>その後、Writefull有料プランのご契約期間がわかる明細を
                                <a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a>までお送りください。ご購入いただいたTrinkaのプラミアムプランのご利用可能期間を、Writefull有料プランのご契約終了までの日数分、無料で延長いたします。</p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <p class="disclaimer-txt"><strong>注意事項：</strong> 1回のご注文で使用できるクーポンや割引は1つのみです。</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>Trinkaで、洗練された英文をもっと簡単に。</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>無料で登録する</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="other_comparision">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Grammarly</h3>
                    </div>
                    <p>かつてない学術専門の英文添削ツールTrinka</p>
                    <a [routerLink]="['/trinka-vs-grammarly']">もっと読む
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Ginger</h3>
                    </div>
                    <p>文法やスペルだけでなく総合的に英文を改善する英文チェッカーTrinka</p>
                    <a [routerLink]="['/trinka-vs-ginger']">もっと読む
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. LanguageTool</h3>
                    </div>
                    <p>総合的に英文の質を改善する英語<a [routerLink]="['/grammar-checker']" class="text-link">文法チェッカー</a>Trinka</p>
                    <a [routerLink]="['/trinka-vs-languagetool']">もっと読む
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="disclaimerContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="disclaimercontents">
                    <p>
                        <span>免責事項：</span> 本ページで言及する製品名および企業名は、各所有者の商標™または登録商標®です。ここでの言及は、各社との提携や推奨を意味するものではありません。本ページで記載されている比較は、製品のパンフレットやウェブサイトから得られた製品情報、および2021年9月15日に同じ条件下で行われたテストに基づいて作成されています。ご不明点は、
                        <a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a>までお問い合わせください。

                    </p>
                </div>
            </div>
        </div>
    </div>
</div>